import { BaseAPI } from "@utils/base-api";
import { GetPostCheckoutChargesResponseDto } from "@./types/charges";

export class ChargesAPI extends BaseAPI {

  public async getPostCheckoutCharges(katkinCustomerId: string): Promise<GetPostCheckoutChargesResponseDto> {
    try {
      const response = await this.axios.get("/customer/post-checkout-charges", {
        params: {
          katkinCustomerId,
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error getting charges post checkout", error);
      throw error;
    }

  }

}
